import { render, staticRenderFns } from "./Archiving.vue?vue&type=template&id=cab1dab4&"
import script from "./Archiving.vue?vue&type=script&lang=js&"
export * from "./Archiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports